// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationMessageAboveHeaderCloseBase: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#231f20", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 8 9" width={width} height={height}>
            <path
                fill="currentColor"
                d="M7.105 8.135a.376.376 0 0 0 .53 0 .376.376 0 0 0 0-.53L4.53 4.5l3.105-3.105a.376.376 0 0 0 0-.53.376.376 0 0 0-.53 0L4 3.97.895.865a.376.376 0 0 0-.53 0 .376.376 0 0 0 0 .53L3.47 4.5.365 7.605a.376.376 0 0 0 0 .53.376.376 0 0 0 .53 0L4 5.03z"
            />
        </svg>
    );
};

export default React.memo(NotificationMessageAboveHeaderCloseBase);
